import { render } from "./shopLocation.vue?vue&type=template&id=19a1037f"
import script from "./shopLocation.vue?vue&type=script&lang=js"
export * from "./shopLocation.vue?vue&type=script&lang=js"

import "./shopLocation.vue?vue&type=style&index=0&id=19a1037f&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__